import { Component, Input } from '@angular/core';
import { TileWithFAIconSmallContent } from '../../models/tile-with-fa-icon-small-content.model';
import { GlobalElementType } from '../../enums/global-element-type-uid.enum';
import { IconWeight } from '@challenger/care/models/icon-weight.enum';
import { Setting } from '../../models/setting.model';
import { environment } from '../../../../environments/environment';
import { SectionService } from '../../services/section.service';

@Component({
  selector: 'vm-custom-tile-with-fa-icon-small-section',
  templateUrl: './tile-with-fa-icon-small-section.component.html',
  styleUrls: ['./tile-with-fa-icon-small-section.component.scss'],
})
export class TileWithFAIconSmallSectionComponent {
  @Input() tiles: TileWithFAIconSmallContent[];
  @Input() type: GlobalElementType;
  IconWeight = IconWeight;
  isExternalLinkRegex = new RegExp('https?');
  strapiUrl = environment.strapiURL;

  globalElementType = GlobalElementType;

  constructor() {}
}
